export default "__VITE_ASSET__DHgnfQ7d__"